import { queryOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'
import type { ResUserQuery } from '@/lib/queries/business/v2/user/types'

export interface ResUserQueryExtended extends ResUserQuery {
  hasSubscription: boolean
  isAdmin: boolean
  isFreeTrialAvailable: boolean
}

export const getUserQuery = queryOptions<ResUserQueryExtended | null>({
  queryKey: [API_ENDPOINTS.business.v2.user.index],
  queryFn: () => {
    return w.get(API_ENDPOINTS.business.v2.user.index).json()
  },
  select: (response) => {
    if (!response) {
      return null
    }

    return {
      ...response,
      hasSubscription: !!response?.subscription,
      isAdmin: response?.user?.isAdmin ?? false,
      isFreeTrialAvailable: response?.freeTrialAvailable ?? false,
    }
  },
  retry: 0,
})
